'use strict';

var _FirebaseAuth = require('./FirebaseAuth');

var _FirebaseAuth2 = _interopRequireDefault(_FirebaseAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FirebaseAuth = _FirebaseAuth2.default;
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./client/components/react-firebaseui/index.js